<app-side-menu>
  <div class="supplier-form-content">
    <!-- Header -->
    <div class="row mb-4">
      <div class="col-12">
        <div class="page-header">
          <div class="d-flex align-items-center">
            <app-button 
              text="Voltar"
              color="var(--secondary-color)"
              (buttonClick)="cancel()"
              className="me-3">
              <i class="fas fa-arrow-left me-2"></i>
            </app-button>
            <div>
              <h1 class="page-title">
                <i class="fas fa-truck me-3"></i>
                {{ supplierId ? 'Editar Fornecedor' : 'Novo Fornecedor' }}
              </h1>
              <p class="page-subtitle">{{ supplierId ? 'Atualize as informações do fornecedor' : 'Cadastre um novo fornecedor no sistema' }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Formulário -->
    <div class="row">
      <div class="col-12">
        <div class="supplier-form-card">
          <app-form-shell
            [tabs]="availableTabs"
            [activeTab]="activeTab"
            (tabChange)="selectTab($event)">
          </app-form-shell>

          <!-- Step 1: Identificação -->
          <div *ngIf="activeTab === 'identification'" class="form-section">
            <h3 class="section-title">
              <i class="fas fa-building me-2"></i>
              Identificação da Empresa
            </h3>
            
            <div [formGroup]="formStep1" class="row g-3">
              <div class="col-md-6">
                <label for="companyName" class="form-label">Razão Social *</label>
                <input 
                  type="text" 
                  id="companyName"
                  class="form-control"
                  formControlName="companyName"
                  [class.is-invalid]="isFieldInvalid(1, 'companyName')"
                  placeholder="Digite a razão social">
                <div class="invalid-feedback" *ngIf="isFieldInvalid(1, 'companyName')">
                  A razão social é obrigatória.
                </div>
              </div>

              <div class="col-md-6">
                <label for="tradeName" class="form-label">Nome Fantasia</label>
                <input 
                  type="text" 
                  id="tradeName"
                  class="form-control" 
                  formControlName="tradeName"
                  placeholder="Digite o nome fantasia">
              </div>

              <div class="col-md-6">
                <label for="cnpj" class="form-label">CNPJ *</label>
                <input 
                  type="text" 
                  id="cnpj"
                  class="form-control" 
                  formControlName="cnpj"
                  [class.is-invalid]="isFieldInvalid(1, 'cnpj')"
                  (input)="onCnpjInput($event)"
                  (blur)="onCnpjBlur()"
                  placeholder="00.000.000/0000-00">
                <div class="invalid-feedback" *ngIf="isFieldInvalid(1, 'cnpj')">
                  <span *ngIf="formStep1.get('cnpj')?.errors?.['required']">O CNPJ é obrigatório.</span>
                  <span *ngIf="formStep1.get('cnpj')?.errors?.['minlength']">CNPJ inválido.</span>
                  <span *ngIf="formStep1.get('cnpj')?.errors?.['cnpjExists']">Já existe um fornecedor com este CNPJ.</span>
                </div>
              </div>

              <div class="col-md-6">
                <label for="stateRegistration" class="form-label">Inscrição Estadual</label>
                <input 
                  type="text" 
                  id="stateRegistration"
                  class="form-control" 
                  formControlName="stateRegistration"
                  placeholder="Digite a inscrição estadual">
              </div>
            </div>
          </div>

          <!-- Step 2: Contato -->
          <div *ngIf="activeTab === 'contact'" class="form-section">
            <h3 class="section-title">
              <i class="fas fa-address-book me-2"></i>
              Informações de Contato
            </h3>
            
            <div [formGroup]="formStep2" class="row g-3">
              <div class="col-md-6">
                <label for="email" class="form-label">E-mail *</label>
                <input 
                  type="email" 
                  id="email"
                  class="form-control" 
                  formControlName="email"
                  [class.is-invalid]="isFieldInvalid(2, 'email')"
                  placeholder="exemplo@empresa.com">
                <div class="invalid-feedback" *ngIf="isFieldInvalid(2, 'email')">
                  <span *ngIf="formStep2.get('email')?.errors?.['required']">O e-mail é obrigatório.</span>
                  <span *ngIf="formStep2.get('email')?.errors?.['email']">Informe um e-mail válido.</span>
                </div>
              </div>

              <div class="col-md-6">
                <label for="primaryPhone" class="form-label">Telefone Principal *</label>
                <input 
                  type="tel" 
                  id="primaryPhone"
                  class="form-control" 
                  formControlName="primaryPhone"
                  [class.is-invalid]="isFieldInvalid(2, 'primaryPhone')"
                  (input)="onPhoneInput($event, 'primaryPhone')"
                  placeholder="(11) 99999-9999">
                <div class="invalid-feedback" *ngIf="isFieldInvalid(2, 'primaryPhone')">
                  <span *ngIf="formStep2.get('primaryPhone')?.errors?.['required']">O telefone é obrigatório.</span>
                  <span *ngIf="formStep2.get('primaryPhone')?.errors?.['minlength']">Telefone inválido (mínimo 10 dígitos).</span>
                </div>
              </div>

              <div class="col-md-6">
                <label for="secondaryPhone" class="form-label">Telefone Secundário</label>
                <input 
                  type="tel" 
                  id="secondaryPhone"
                  class="form-control"
                  formControlName="secondaryPhone"
                  (input)="onPhoneInput($event, 'secondaryPhone')"
                  placeholder="(11) 99999-9999">
              </div>

              <div class="col-md-6">
                <label for="supplierCategory" class="form-label">Categoria</label>
                <select 
                  id="supplierCategory"
                  class="form-select" 
                  formControlName="supplierCategory">
                  <option value="">Selecione uma categoria</option>
                  <option value="materiais">Materiais</option>
                  <option value="servicos">Serviços</option>
                  <option value="equipamentos">Equipamentos</option>
                  <option value="tecnologia">Tecnologia</option>
                  <option value="outros">Outros</option>
                </select>
              </div>

              <div class="col-md-6">
                <label for="street" class="form-label">Rua</label>
                <input 
                  type="text" 
                  id="street"
                  class="form-control" 
                  formControlName="street"
                  placeholder="Digite a rua">
              </div>

              <div class="col-md-2">
                <label for="number" class="form-label">Número</label>
                <input 
                  type="text" 
                  id="number"
                  class="form-control" 
                  formControlName="number"
                  placeholder="Nº">
              </div>

              <div class="col-md-4">
                <label for="complement" class="form-label">Complemento</label>
                <input 
                  type="text" 
                  id="complement"
                  class="form-control" 
                  formControlName="complement"
                  placeholder="Apto, sala, etc.">
              </div>

              <div class="col-md-4">
                <label for="neighborhood" class="form-label">Bairro</label>
                <input 
                  type="text" 
                  id="neighborhood"
                  class="form-control" 
                  formControlName="neighborhood"
                  placeholder="Digite o bairro">
              </div>

              <div class="col-md-4">
                <label for="city" class="form-label">Cidade</label>
                <input 
                  type="text" 
                  id="city"
                  class="form-control" 
                  formControlName="city"
                  placeholder="Digite a cidade">
              </div>

              <div class="col-md-2">
                <label for="state" class="form-label">Estado</label>
                <input 
                  type="text" 
                  id="state"
                  class="form-control" 
                  formControlName="state"
                  placeholder="UF">
              </div>

              <div class="col-md-2">
                <label for="zipCode" class="form-label">CEP</label>
                <input 
                  type="text" 
                  id="zipCode"
                  class="form-control" 
                  formControlName="zipCode"
                  [class.is-invalid]="!!cepError"
                  (input)="onZipCodeInput($event)"
                  placeholder="00000-000">
                <div class="invalid-feedback" *ngIf="cepError">{{ cepError }}</div>
                <small class="text-muted" *ngIf="isLoadingCep"><i class="fa fa-spinner fa-spin me-1"></i> Consultando CEP...</small>
              </div>
            </div>
          </div>

          <!-- Step 3: Status & Observações -->
          <div *ngIf="activeTab === 'status'" class="form-section">
            <h3 class="section-title">
              <i class="fas fa-cog me-2"></i>
              Status e Configurações
            </h3>
            
            <div [formGroup]="formStep3" class="row g-3">
              <div class="col-md-6">
                <label for="status" class="form-label">Status do Fornecedor</label>
                <div *ngIf="loadingStatuses" class="loading-statuses">
                  <i class="fas fa-spinner fa-spin me-2"></i>
                  Carregando status...
                </div>
                <select
                  *ngIf="!loadingStatuses"
                  id="status"
                  class="form-select"
                  formControlName="status">
                  <option value="">Selecione um status</option>
                  <option *ngFor="let status of statusOptions" [value]="status.name">
                    {{ status.name }}
                  </option>
                </select>
              </div>

              <div class="col-md-6">
                <div class="form-check">
                  <input 
                    type="checkbox" 
                    id="blocked"
                    class="form-check-input" 
                    formControlName="blocked">
                  <label for="blocked" class="form-check-label">Fornecedor Bloqueado</label>
                </div>
              </div>

              <div class="col-12">
                <label for="notes" class="form-label optional">Observações</label>
                <textarea 
                  id="notes"
                  class="form-control" 
                  formControlName="notes"
                  rows="4"
                  placeholder="Informações adicionais sobre o fornecedor..."></textarea>
              </div>
            </div>
          </div>

          <!-- Anexos (apenas para edição) -->
          <div *ngIf="activeTab === 'status' && supplierId" class="form-section">
            <h3 class="section-title">
              <i class="fas fa-paperclip me-2"></i>
              Anexos
            </h3>
            
            <div class="file-upload">
              <input type="file" (change)="onFileSelected($event)" id="fileInput" />
              <label for="fileInput" class="file-upload-label">
                <i class="fas fa-cloud-upload-alt"></i>
                <span>Clique para selecionar um arquivo ou arraste aqui</span>
              </label>
            </div>

            <div *ngIf="uploading" class="upload-progress">
              <div class="d-flex justify-content-between mb-2">
                <span>Enviando arquivo...</span>
                <span>{{ uploadProgress }}%</span>
              </div>
              <div class="progress">
                <div class="progress-bar" [style.width.%]="uploadProgress"></div>
              </div>
            </div>

            <div *ngIf="attachments && attachments.length > 0" class="attachments-list">
              <h5 class="mb-3">Arquivos Anexados</h5>
              <div *ngFor="let attachment of attachments" class="attachment-item">
                <div class="attachment-info">
                  <i class="fas fa-file attachment-icon"></i>
                  <div class="attachment-details">
                    <h6>{{ attachment.originalFileName }}</h6>
                    <small>{{ attachment.fileSize || 'Tamanho não disponível' }}</small>
                  </div>
                </div>
                <div class="d-flex align-items-center">
                  <span class="attachment-category me-2">{{ attachment.category || 'Sem categoria' }}</span>
                  <a [href]="attachment.filePath" target="_blank" class="btn btn-sm btn-outline-primary me-2">
                    <i class="fas fa-download"></i>
                  </a>
                  <button class="btn btn-sm btn-outline-danger" (click)="removeAttachment(attachment)">
                    <i class="fas fa-trash"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>



          <div class="navigation-buttons">
            <button *ngIf="isFirstTab()" type="button" class="btn btn-secondary" (click)="cancel()">
              <i class="fas fa-arrow-left me-2"></i>
              Voltar
            </button>
            <button *ngIf="!isFirstTab()" type="button" class="btn btn-secondary" (click)="goToPreviousTab()">
              <i class="fas fa-arrow-left me-2"></i>
              Anterior
            </button>

            <button *ngIf="!isLastTab()" type="button" class="btn btn-primary" (click)="goToNextTab()">
              Próximo
              <i class="fas fa-arrow-right ms-2"></i>
            </button>

            <button *ngIf="isLastTab()" type="button" class="btn btn-success" [disabled]="isSubmitting || !isTabValid(activeTab)" (click)="save()">
              <i class="fas fa-save me-2"></i>
              {{ isSubmitting ? 'Salvando...' : 'Salvar Fornecedor' }}
              <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm ms-2"></span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-side-menu>
